import { useTranslation } from 'react-i18next';

import { type Database, useSetDatabaseLabels } from '@/entities/database';
import { ResourceLabelsDialog } from '@/features/resource-labels';

/** Labels of a database: the shared resource label picker (the same one notes and groups use). */
export function DatabaseLabelsDialog({
  database,
  onClose,
}: {
  database: Database;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const save = useSetDatabaseLabels(database.id);
  return (
    <ResourceLabelsDialog
      kind="database"
      title={t('databases.labels.title', { name: database.name })}
      workspaceId={database.workspace_id}
      current={database.labels}
      pending={save.isPending}
      error={save.error}
      onSave={(labelIds) => {
        save.mutate(labelIds, { onSuccess: onClose });
      }}
      onClose={onClose}
    />
  );
}
